<template>
  <Teleport to="body">
    <Transition name="modal">
      <div
        v-if="isVisible"
        class="fixed inset-0 z-[100] flex items-center justify-center p-4"
      >
        <!-- Backdrop -->
        <div 
          class="absolute inset-0 bg-black/60 backdrop-blur-sm"
          @click.prevent
        />
        
        <!-- Modal -->
        <div class="relative bg-white dark:bg-dark-background rounded-2xl shadow-2xl max-w-md w-full p-8 transform transition-all">
          <!-- Icon -->
          <div class="flex justify-center mb-6">
            <div class="w-20 h-20 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
              <ClockIcon class="w-10 h-10 text-amber-600 dark:text-amber-400" />
            </div>
          </div>
          
          <!-- Content -->
          <div class="text-center">
            <h2 class="text-2xl font-bold text-light-text-primary dark:text-dark-text-primary mb-3">
              Sesión Expirada
            </h2>
            <p class="text-light-text-secondary dark:text-dark-text-secondary mb-8">
              Tu sesión ha expirado por seguridad. Por favor, inicia sesión de nuevo para continuar.
            </p>
            
            <div class="flex flex-col-reverse sm:flex-row gap-3 w-full">
              <button
                type="button"
                @click="handleCancel"
                class="w-full sm:flex-1 py-3 px-6 rounded-xl font-semibold text-lg border-2 border-light-border dark:border-dark-border
                       text-light-text-primary dark:text-dark-text-primary bg-transparent
                       hover:bg-light-background-secondary dark:hover:bg-dark-background-secondary transition duration-300"
              >
                Cancelar
              </button>
              <button
                type="button"
                @click="handleRedirectToLogin"
                class="w-full sm:flex-1 bg-light-cta-bg text-light-cta-text dark:bg-dark-accent dark:text-dark-cta-text 
                       py-3 px-6 rounded-xl font-semibold text-lg
                       hover:opacity-90 transition duration-300 shadow-lg
                       flex items-center justify-center gap-2"
              >
                <ArrowRightOnRectangleIcon class="w-5 h-5" />
                Iniciar sesión
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { ClockIcon, ArrowRightOnRectangleIcon } from '@heroicons/vue/24/outline'
import { useAuthStore } from '@/stores/auth'

// Props
defineProps({
  isVisible: {
    type: Boolean,
    default: false
  }
})

// Emits
const emit = defineEmits(['close'])

// Setup
const router = useRouter()
const authStore = useAuthStore()

// Methods
const handleCancel = () => {
  emit('close')
}

const handleRedirectToLogin = async () => {
  // Limpiar sesión
  await authStore.logout()
  
  // Cerrar modal
  emit('close')
  
  // Redirigir al login
  router.push('/login')
}
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .relative,
.modal-leave-to .relative {
  transform: scale(0.9);
}
</style>




